import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggleable', 'button'];
  static values = { id: String };

  connect() {
    this.toggleClass = this.data.get('class') || 'hidden';

    if (this.hasButtonTarget)
      if (this.isOpen)
        this.buttonTarget.innerHTML = this.buttonTarget.dataset.opened;
      else this.buttonTarget.innerHTML = this.buttonTarget.dataset.closed;

    // Remember target classNames for reset()
    this.savedClassNames = Array.from(this.toggleableTargets).map(
      (target) => target.className,
    );

    this.restoreState();
  }

  toggle(event) {
    if (event) event.preventDefault();

    if (this.hasButtonTarget) {
      this.buttonTarget.classList.toggle('open');
      if (this.isOpen)
        this.buttonTarget.innerHTML = this.buttonTarget.dataset.opened;
      else this.buttonTarget.innerHTML = this.buttonTarget.dataset.closed;
    }

    Array.from(this.toggleableTargets).forEach((target) => {
      target.classList.toggle(this.toggleClass);
    });

    this.saveState();
  }

  reset(event) {
    event.preventDefault();

    Array.from(this.toggleableTargets).forEach((target, index) => {
      target.className = this.savedClassNames[index];
    });
  }

  saveState() {
    if (!this.idValue) return;

    const state = this.isOpen ? 'open' : 'closed';
    localStorage.setItem('toggle.' + this.idValue, state);
  }

  restoreState() {
    if (!this.idValue) return;

    const state = localStorage.getItem('toggle.' + this.idValue);
    if (!state) return;

    if ((state === 'open') !== this.isOpen) this.toggle();
  }

  get isOpen() {
    if (!this.hasButtonTarget) return false;

    return this.buttonTarget.classList.contains('open');
  }
}
